import { createHrefs, createUtm } from "@indietabletop/appkit";

function withParams(path: string, init?: Record<string, string>) {
  if (!init) {
    return path;
  }

  return `${path}?${new URLSearchParams(init)}`;
}

type AccountParams = {
  redirectTo?: string;
};

export type BuyParams = {
  note: "backToIt" | "loginNeeded";
};

export const hrefs = createHrefs({
  utm: createUtm({
    source: "indietabletopclub",
    medium: "referral",
    campaign: "spacegitsapp",
  }),

  hrefs: {
    login: (params?: AccountParams) => withParams(`~/login`, params),
    join: (params?: AccountParams) => withParams(`~/join`, params),
    password: () => `~/password`,
    dashboard: () => `~/`,
    account: () => `~/settings`,
    rules: (params?: Partial<BuyParams>) => withParams(`~/rules`, params),
    qsr: () => `~/rules/quick-start`,
    psg: () => `https://planetsmashergames.com`,

    // Currently same as /rules, but keep it separate to identify the intent:
    // Should this link to the /buy page once we have it or it's actually rules?
    buy: (params?: Partial<BuyParams>) => withParams(`~/rules`, params),
  },
});
